<form class="form-container" autocomplete="on" [formGroup]="facilityForm" (ngSubmit)="Submit()">
  <div class="container-vertical">
    <label for="name" class="label">facility name:</label>
    <input id="name" class="input" formControlName="name" />
    <label for="description" class="label">description:</label>
    <textarea id="description" class="textarea" formControlName="description"></textarea>
  </div>
  <div class="container-horizontal">
    <div class="container-vertical">
      <span class="label">Asset type:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="assetType" placeholder="select asset type" panelClass="topunit">
          @for (assetType of assetTypeOptions; track assetType) {
          <mat-option value="{{ assetType }}">{{ assetType }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="container-vertical">
      <span class="label">Facility type:</span>
      <mat-form-field class="iconf-select" appearance="outline">
        <mat-select formControlName="facilityType" placeholder="select facility type" panelClass="topunit">
          @for (facilityType of facilityTypeOptions; track facilityType) {
          <mat-option value="{{ facilityType }}">{{ facilityType }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="actions">
    <button class="iconf-btn-filled minw150 minh40" type="button" (click)="this.cancel.emit()">Cancel</button>
    <button class="iconf-btn-filled minw150 minh40" type="submit">{{ submitText }}</button>
  </div>
</form>
